import { NgModule } from '@angular/core';
import { ComponentsModule } from '../components/components.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DesktopAppComponent } from './desktop.app.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { FilterModule } from '../panels/filter-panel/filter.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [
    DesktopAppComponent,
  ],
    imports: [
        CommonModule,
        ComponentsModule,
        NgScrollbarModule.withConfig({autoHeightDisabled: false, autoWidthDisabled: true}),
        TranslateModule,
        FormsModule,
        NgbModule,
        QRCodeModule,
        FilterModule,
        InfiniteScrollModule,
        ReactiveFormsModule,
    ]
})
export class DesktopAppModule {
  public static components = {
    DesktopAppComponent
  }
}
